<div class="efx-row-datasource mx-0 source_item">
  <div class="item_title">
    <b style="font-size: 24px;">{{data.message}}</b>
  </div>
  <div class="wrapper_data">
    <div class="item_values">
      @if (bofuenteSeleccionada) {
        <div class="item_value">
          @if (data.bodominio) {
            <span class="title">GEO: </span>
          }
          @if (!data.bodominio) {
            <span class="title">Dominio: </span>
          }
          <span class="value">
            @if (!data.bodominio) {
              <p class="efx-row-input-data">
                <input [(ngModel)]="dominio" class="form-control efx-input" type="text"/>
              </p>
            }
            @if (data.bodominio) {
              <p class="efx-row-input-data">
                <b>{{dominio}}</b>
              </p>
            }
          </span>
        </div>
      }

      @if (bofuenteSeleccionada) {
        <div class="item_value">
          @if (data.bodominio) {
            <span class="title">RDS: </span>
          }
          @if (!data.bodominio) {
            <span class="title">SubDominio(s): </span>
          }
          <span class="value">
            <p class="efx-row-input-data">
              <input style="width: 410px;" [(ngModel)]="subdominio" class="form-control efx-input" type="text"/>
            </p>
          </span>
        </div>
      }
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button class="efx-button-secondary button-secondary" (click)="onNoClick()">{{data.onCancelText === undefined ? 'Cancelar' : data.onSubmitText}}</button>&nbsp;
    <button class="efx-button-primary button-primary" (click)="onSubmit()" cdkFocusInitial
    [disabled]="btnStatus">{{data.onSubmitText === undefined ? 'Guardar' : data.onSubmitText}}</button>
  </div>
</div>
<div>
  <p style="font-size: small;font-weight: bold;text-align: center;">** Para agregar más de un Subdominio, puede hacerlo separándolos por coma (Ej: uno, dos, etc)</p>
</div>